import axios, { AxiosInstance } from 'axios';

import { API_METRICS_URL, API_METRICS_V2_URL, API_PULSE_URL, API_REPORTS_URL, API_USER_URL } from '../constants/app';

const createInstance = (baseURL: string): AxiosInstance =>
  axios.create({
    baseURL,
    timeout: 90000,
    withCredentials: true,
  });

export const metricsInstance = createInstance(API_METRICS_URL);
export const metricsV2Instance = createInstance(API_METRICS_V2_URL);
export const pulseInstance = createInstance(API_PULSE_URL);
export const reportsInstance = createInstance(API_REPORTS_URL);
export const userInstance = createInstance(API_USER_URL);
